export const termsContent = `# Terms of Service

Last updated: December 1, 2024

## 1. Introduction

Welcome to Quick Chef ("the App"). By downloading, accessing, or using Quick Chef, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the App.

## 2. Definitions

- "Quick Chef" or "the App" refers to our mobile application, including all its features and services
- "User" or "you" refers to any individual who downloads, accesses, or uses the App
- "Content" refers to recipes, images, text, and other materials available through the App
- "User Content" refers to any content submitted by users, including recipes and comments

## 3. Account Terms

### 3.1 Account Creation
- You must be at least 18 years old to create an account
- You must provide accurate and complete information when creating an account
- You are responsible for maintaining the security of your account credentials
- You must notify us immediately of any unauthorized access to your account

### 3.2 Account Responsibilities
- You are solely responsible for all activity that occurs under your account
- You agree not to share your account credentials with any third party
- You agree to keep your account information up to date

## 4. Use of Service

### 4.1 Acceptable Use
You agree to use the App only for lawful purposes and in accordance with these Terms. You agree not to:
- Use the App in any way that violates applicable laws or regulations
- Post or transmit any content that is unlawful, harmful, threatening, or abusive
- Attempt to gain unauthorized access to any part of the App
- Use the App to distribute spam or malicious content
- Interfere with or disrupt the App's services

### 4.2 AI Features
- The AI recipe suggestions are provided as recommendations only
- We do not guarantee the accuracy or suitability of AI-generated content
- You should use your judgment when following recipe suggestions
- Always check ingredients for allergens and safety

## 5. Content and Intellectual Property

### 5.1 App Content
- All content provided through the App is owned by Quick Chef or its licensors
- You may not copy, modify, or distribute App content without permission
- The App's design, logos, and features are protected by intellectual property laws

### 5.2 User Content
- You retain ownership of any content you submit to the App
- By submitting content, you grant Quick Chef a worldwide, non-exclusive license to use, modify, and display your content
- You are responsible for ensuring you have the right to share any content you submit

## 6. Premium Features

### 6.1 Subscriptions
- Premium features require a paid subscription
- Subscription fees are clearly displayed before purchase
- Subscriptions automatically renew unless cancelled
- Refunds are provided according to the platform's (Google Play) policies

## 7. Privacy and Data

### 7.1 Data Collection
- We collect and process data as described in our Privacy Policy
- By using the App, you consent to our data collection practices
- You can control certain data collection features through App settings

### 7.2 Data Security
- We implement reasonable security measures to protect your data
- You are responsible for maintaining the security of your account credentials
- We cannot guarantee absolute security of data transmitted through the internet

## 8. Modifications to Service

We reserve the right to:
- Modify or discontinue any part of the App
- Change subscription fees with reasonable notice
- Update these Terms of Service
- Modify or remove features

## 9. Limitation of Liability

### 9.1 Disclaimer
The App is provided "as is" without warranties of any kind. We do not guarantee that:
- The App will always be available or error-free
- Recipe suggestions will meet your specific needs
- Ingredients or nutritional information will be completely accurate

### 9.2 Liability Limits
We are not liable for:
- Any indirect, incidental, or consequential damages
- Issues arising from following recipe suggestions
- Technical problems or data loss
- User-generated content

## 10. Termination

### 10.1 Account Termination
We may terminate or suspend your account if you:
- Violate these Terms of Service
- Engage in fraudulent activity
- Misuse the App or its features
- Create multiple accounts for abusive purposes

### 10.2 Effects of Termination
Upon termination:
- Your access to premium features will end
- You may lose access to saved content
- Subscription fees are not refundable
- Some Terms will survive termination

## 11. Contact Information

For questions about these Terms of Service, please contact:
- Email: funroboticshere@gmail.com
- Website: www.quickchef.app

## 12. Additional Terms

### 12.1 Changes to Terms
We reserve the right to modify these Terms at any time. We will notify users of significant changes through the App or via email.

### 12.2 Severability
If any provision of these Terms is found to be unenforceable, the remaining provisions will remain in effect.

## 13. Agreement

By using Quick Chef, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service and our Privacy Policy.
`;